import { type ResponseData, useApiQuery } from '@vrplatform/data';

export const STORYBOOK_OWNER_STATEMENT_SUMMARY_LAYOUT_OPTIONS_QUERY_KEY =
  'owner-statement-summary-layout-options';

type Layout = ResponseData<'get:/statements/layouts'>['data'][number];

export type OwnerStatementSummaryLayoutOption = {
  label: string;
  value: string;
};

type OwnerStatementSummaryLayoutOptionsData = {
  defaultLayoutId: string | null;
  options: OwnerStatementSummaryLayoutOption[];
};

export const useOwnerStatementSummaryLayoutOptionsQuery = () => {
  return useApiQuery<
    OwnerStatementSummaryLayoutOptionsData,
    Record<string, never>
  >(
    async (client, signal) => {
      const res = await client.GET('/statements/layouts', { signal });

      if (res.error) throw res.error;

      const data = res.data.data;
      const defaultLayout = data.find((layout) => layout.isDefault);
      const layouts = data.filter((layout) => !layout.isDefault);
      const options = [defaultLayout, ...layouts]
        .filter((layout): layout is Layout => !!layout?.id)
        .map((layout) => ({
          label: layout.name,
          value: layout.id,
        }));

      return {
        defaultLayoutId: defaultLayout?.id ?? options[0]?.value ?? null,
        options,
      };
    },
    {
      queryGroup: 'owner-statements',
      uniqueQueryKey: 'owner-statement-summary-layout-options',
      variables: {},
      hideNotification: true,
      storybookQueryKey:
        STORYBOOK_OWNER_STATEMENT_SUMMARY_LAYOUT_OPTIONS_QUERY_KEY,
    }
  );
};
